import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./portafolio.css";

// Component imports
import Navbar from "./Navbar/Navbar";
import AboutMe from "./AboutMe/AboutMe";
import ProjectSection from "./ProjectCards/ProjectCard";
import Technologies from "./Technologies/Technologies";
import Footer from "./Footer/Footer";

const Portfolio = ({ language, darkMode, toggleDarkMode }) => {
  const { t } = useTranslation('content');
  const [emailcopied, setEmailcopied] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = window.localStorage.getItem('theme');
    return savedTheme ? savedTheme === 'light' : darkMode;
  });

  // Sync dark mode state with props and localStorage
  useEffect(() => {
    setIsDarkMode(darkMode);
    window.localStorage.setItem('theme', darkMode ? 'light' : 'dark');
    
    // Update body background
    document.body.style.backgroundColor = darkMode ? '#1a1a1a' : '#f9fafb';
  }, [darkMode]);

  // Email copy handler
  const handleEmailCopy = async () => {
    const email = "jeronimoriveros@gmail.com";
    try {
      await navigator.clipboard.writeText(email);
      setEmailcopied(true);
      setTimeout(() => {
        window.open("https://mail.google.com/mail/u/0/#inbox?compose=new", "_blank");
        setEmailcopied(false);
      }, 1500);
    } catch (err) {
      console.error('Error copying email:', err);
    }
  };

  return (
    <div className="fullcontent">
      <section className={`portafolio-scroll ${!isDarkMode ? 'back' : ''}`}>
        {/* Navigation */}
        <Navbar 
          toggleLanguage={language}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
        />

        {/* About Section */}
        <AboutMe darkMode={darkMode} />
        
        {/* Projects Section */}
        <header className="projects-header">
          <h1 id="project-title">{t('content.projects')}</h1>
          <p id="project-text">{t('content.projectsDescription')}</p>
        </header>
        <ProjectSection darkMode={darkMode} />

        {/* Technologies Section */}
        <header className="tecnologies-header">
          <h1 id="tecnologies-title">{t('content.technologies')}</h1>
        </header>
        <Technologies darkMode={darkMode} />

        {/* Footer */}
        <Footer 
          darkMode={darkMode}
          emailcopied={emailcopied}
          handleEmailCopy={handleEmailCopy}
        />
      </section>
    </div>
  );
};

export default Portfolio;